import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FollowedPropertiesComponent } from './component/followed-properties/followed-properties.component';
const routes: Routes = [{ path: '', component: FollowedPropertiesComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FollowedPropertiesRoutingModule {}
